import React, { useEffect, useState, useContext } from 'react';
import { Grid, FormLabel, FormHelperText, CircularProgress, Typography } from '@material-ui/core';
import { SecondaryButton, TextBox, YesNoButton, SingelSelect, SelectBox } from '../../../../Core/FormInput';
import AppContext from '../../../../App/AppContext';
import { getTCardEventTypesByID, postTCardEventTypes } from '../../../../Core/Service/TCard-EventTypes-service';

const AddUpdateEventTypes = (props) => {
    const { showToast } = useContext(AppContext);
    const [loading, setLoading] = useState(false);
    const [state, setState] = useState({
        tCardEventTypeDescription: '',
        errors: {}
    });

    useEffect(() => {
        const fetchWorkTypes = async () => {
            if (props.eventTypeID) {
                setLoading(true);
                try {
                    let res = await getTCardEventTypesByID(props.eventTypeID);
                    let data = res?.data?.list?.table[0] || {};
                    if (res.success) {
                        setState((st) => ({
                            ...st,
                            tCardEventTypeDescription: data.tCardEventTypeDescription,
                            tCardEventTypeID: data.tCardEventTypeID,
                            errors: {}
                        }));
                    }
                } finally {
                    setLoading(false);
                }
            }
        };
        fetchWorkTypes();
    }, [props.eventTypeID]);

    const handleInput = (e) => {
        const { name, value } = e.target;
        setState((st) => ({
            ...st,
            [name]: value,
            errors: { ...st.errors, [name]: '' }
        }));
    };

    const handleValidation = () => {
        let errors = {};
        let formIsValid = true;

        if (!state.tCardEventTypeDescription.trim()) {
            formIsValid = false;
            errors.tCardEventTypeDescription = 'Description is required.';
        }
        setState((st) => ({
            ...st,
            errors: errors
        }));

        return formIsValid;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (handleValidation()) {
            setLoading(true);
            try {
                const data = {
                    tCardEventTypeID: props.eventTypeID || null,
                    tCardEventTypeDescription: state.tCardEventTypeDescription,
                };
                let res = await postTCardEventTypes(data);
                if (res.data.success) {
                    showToast(`Event Type ${props.eventTypeID ? 'Updated' : 'Added'} successfully`);
                    props.onClose(true);
                } else {
                    console.error(res.message);
                }
            } catch (error) {
                console.error('Error submitting data:', error);
            } finally {
                setLoading(false);
            }
        }
    };

    return (
        <div>
            {loading ? (
                <div style={{ margin: '56px 270px' }}>
                    <CircularProgress style={{ marginLeft: -20 }} />
                </div>
            ) : (
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <FormLabel className="mandatoryfields">Description*</FormLabel>
                        <TextBox autoFocus onChange={handleInput} value={state.tCardEventTypeDescription} name="tCardEventTypeDescription" />
                        {state.errors.tCardEventTypeDescription && (
                            <FormHelperText className="mandatoryfields">{state.errors.tCardEventTypeDescription}</FormHelperText>
                        )}
                    </Grid>

                    <Grid item xs={12} style={{ marginTop: 20, marginBottom: 15 }}>
                        <SecondaryButton fullWidth onClick={handleSubmit}>
                            Submit
                        </SecondaryButton>
                    </Grid>
                </Grid>
            )}
        </div>
    );
};

export default AddUpdateEventTypes;
